// HKDSE 2023 Paper 1 Knowledge Graph Samples - Combined
// Merged from hkdse2023Samples.js

import { hkdse2023Samples } from './hkdse2023Samples.js';

export const hkdse2023Samples_combined = {
  ...hkdse2023Samples
};

// Export individual parts for backward compatibility
export { hkdse2023Samples }; 